import BulgurProduct from 'models/BulgurProduct'

export const packagingInitialState = {
  category: BulgurProduct.category,
  subCategory: BulgurProduct.subCategory,
  GrainSize: BulgurProduct.GrainSize,
  Organic: false,
}
